import React from "react";
import SocialIcons from "./SocialIcons";

export default function Footer({ contact, socials }) {
  return (
    <footer className="border-t border-white/10 bg-black/70 backdrop-blur-lg">
      <div className="max-w-6xl mx-auto px-4 py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <p className="text-white font-semibold">Bookings & Enquiries</p>
          <div className="text-sm text-gray-300">
            <a
              href={contact.whatsappUrl}
              className="hover:text-amber-200 transition"
              target="_blank"
              rel="noopener noreferrer"
            >
              WhatsApp: {contact.whatsapp}
            </a>
            <span className="mx-2 text-white/20">|</span>
            <a
              href={`mailto:${contact.email}`}
              className="hover:text-amber-200 transition"
            >
              {contact.email}
            </a>
          </div>
        </div>

        <SocialIcons socials={socials} />
      </div>
      <div className="text-center text-xs text-gray-400 pb-6">
        © {new Date().getFullYear()} Sasmita & Sangram. All rights reserved. | Designed by Yuktra AI Solutions (www.yuktraai.com)
      </div>
    </footer>
  );
}
